// Regex pattern for valid promo code characters
// Matches: alphanumeric, dash, underscore, percent, exclamation, at, dot, plus
// This allows both alphanumeric codes (e.g., "SAVE20") and email addresses
export const PROMO_CODE_CHAR_PATTERN = /[a-zA-Z0-9\-_%!@.+]/;

// Generates a mask array for react-text-mask input
// Each position allows the same set of valid characters
export const promoCodeMask = (maxLength = 100) => {
  return Array.from(Array(maxLength).keys()).map(() => PROMO_CODE_CHAR_PATTERN);
};
